import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import serviceTypeCodes from 'constants/serviceTypeCodes';
import { VatAddresses } from './VatBreakdown.styles';

export const BE_COUNTRY = 'BE';
export const NL_COUNTRY = 'NL';

export const getUniquePassengersbyCountryAndType = ({ vatCountries }) =>
  vatCountries.reduce((acc, current) => {
    const vats = acc.find((item) => item.countryCode === current.countryCode && item.serviceTypeCode === current.serviceTypeCode);
    return !vats ? [...acc, current] : acc;
  }, []);

export const getMessage = ({ vatCountries = [] }) => {
  const uniques = getUniquePassengersbyCountryAndType({ vatCountries });

  return uniques?.map(({ countryCode, serviceTypeCode }) => {
    if (countryCode === BE_COUNTRY || (countryCode === NL_COUNTRY && serviceTypeCode === serviceTypeCodes.NS)) {
      return (
        <FormattedMessage
          data-testid={`${countryCode}-${serviceTypeCode}`}
          key={`${countryCode}-${serviceTypeCode}`}
          id={`receipt.vatAddress.${countryCode}_${serviceTypeCode}`}
          tagName="small"
          defaultMessage={true}
        />
      );
    }

    return (
      <FormattedMessage
        key={countryCode}
        data-testid={countryCode}
        id={`receipt.vatAddress.${countryCode}`}
        tagName="small"
        defaultMessage={true}
      />
    );
  });
};

const VatAddress = ({ vatInfo, dataCy }) => <VatAddresses data-cy={dataCy}>{getMessage({ vatCountries: vatInfo })}</VatAddresses>;

VatAddress.propTypes = {
  dataCy: PropTypes.string,
  vatInfo: PropTypes.arrayOf(
    PropTypes.shape({
      countryCode: PropTypes.string,
      serviceTypeCode: PropTypes.string
    })
  )
};

export default VatAddress;
